import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import FileBase64 from 'react-file-base64';

import css from 'css';

import { msg, gtmPush } from 'helpers';

import { Checkbox } from 'partials/formElements';
import RemoveIcon from 'images/RemoveIcon';
import Paperclip from 'images/Paperclip';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    addCheckoutOpportunityAttachment,
    removeCheckoutOpportunityAttachment,
    resetCheckoutOpportunityAttachments
} from 'store';

// Keep total base64 payload under Salesforce string limit (~6MB).
const MAX_ATTACHMENTS_BASE64_BYTES = 4000000;
const MAX_ATTACHMENTS_BASE64_LABEL = '4MB';

const Wrapper = styled.section``

const Description = styled.p`
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 30px;
    font-size: 18px;
`;


const Container = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
`;

const UploadWrapper = styled.div`
    flex: 0 0 25%;
    width: 100%;
    border: 1px solid #FFFFFF;
    padding: 10px 10px 0 10px;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: row;
    height: 50px;

    @media(max-width: 767px) {
        flex: 0 0 100%;
        margin-bottom: 15px;
        justify-content: center;
    }

    input[type="file"] {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
    }

    span {
        flex: 0 0 50%;
        width: 100%;
        color: #FFFFFF;
        font-size: 21px;
    }

    svg {
        flex: 0 0 35%;
        align-self: center;
        margin-bottom: 10px;

        @media(max-width: 767px) {
            flex: 0 0 20%;
        }
    
    }
`;

const UploadedFilesList = styled.ul`
    width: 100%;
    margin: 20px 0;
    list-style: none;
    text-align: left;

    ${props => props.error ? `
    &:after {
        content: '${props.error}';
        color: ${css.colors.red};
    }
` : ``}
`;

const UploadedFileItem = styled.li`
    color: #FFF;
    text-decoration: underline;
    padding: 5px 0;
    text-alight: left;

    &:first-child {
        margin-top: 20px;
    }

    &:last-child {
        margin-bottom: 20px;
    }

    svg {
        cursor: pointer;
        margin-right: 15px;
    }
`;

const InputRow = styled.div`
    flex: 0 0 60%;
    width: 100%;
    margin: 10px 30px 0 30px;

    @media(max-width: 767px) {
        flex: 0 0 100%;
    }

    label {
        width: 100%;
        color: #FFF;
        font-size: inherit;
        text-align: left;
        font-size: 21px;

        &::before {
            display: table;
            width: 26px;
            height: 26px;
            border: 1px solid #FFF;
        }

        &:hover::before {
            border: 1px solid #FFF;
        }
    }

    input:checked + label:before {
        border: 1px solid #fff;
    }
`;

class FileUpload extends Component {
    constructor() {
        super();

        this.state = {
            skipFiles: false,
            errors: {
                files: '',
                consent: ''
            },
            isValid: {
                files: false,
                consent: false,
            },
        }
    }

    componentDidMount() {
        this.props.setCheckoutTitle('');
        this.props.setCheckoutSubtitle('');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        this.props.onRef(this)

    }

    _clearFilesError() {
        this.setState(state => ({
            errors: { ...state.errors, files: '' },
            isValid: { ...state.isValid, files: true }
        }));
    }

    _onFileUploaded = (files) => {
        let hasFileAdded = false;

        files.map(file => {
            let object = {};

            object['name'] = file.name;
            object['content'] = file.base64.split("base64,")[1];

            if (this._validateFileExtention(object) && this._validateFilesSize(object)) {
                hasFileAdded = true;
                this.props.addCheckoutOpportunityAttachment(object);
            }
        }, []);

        if (hasFileAdded) {
            // Clear a previous size/extension error once a valid file is accepted.
            this._clearFilesError();
            this.setState({ skipFiles: false });

            this._validateInput('consent');
        }
    }

    _onRemoveFile(file) {
        this.props.removeCheckoutOpportunityAttachment(file);

        // Re-validate remaining attachments and clear stale size errors.
        if (this._validateFilesSize()) {
            this._clearFilesError();
        }
        this._validateInput('consent');
    }

    _handleSkipFiles = () => {
        this.setState({ skipFiles: !this.state.skipFiles });

        if (!this.state.skipFiles) {
            this.props.resetCheckoutOpportunityAttachments();
        }
    }

    _validateFileExtention(file) {
        const extentions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx'];

        if (!extentions.includes(file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase())) {
            this.setState(state => ({
                errors: { ...state.errors, files: msg('invalidFileExtention') },
                isValid: { ...state.isValid, files: false }
            }));

            return false;
        }

        return true;
    }

    _validateFilesSize(newFile) {
        const attachments = this.props.opportunity.attachments || [];
        let totalBase64Length = 0;

        if (undefined !== newFile && newFile.content) {
            totalBase64Length += newFile.content.length;
        }

        attachments.forEach(file => {
            if (file.content) {
                totalBase64Length += file.content.length;
            }
        });

        if (totalBase64Length > MAX_ATTACHMENTS_BASE64_BYTES) {
            this.setState(state => ({
                errors: {
                    ...state.errors,
                    files: msg('fileMaxSizeError') + MAX_ATTACHMENTS_BASE64_LABEL
                },
                isValid: { ...state.isValid, files: false }
            }));

            return false;
        }

        return true;
    }

    _validateInput(key) {
        const opportunity = this.props.opportunity;

        if (key === 'files') {
            if (opportunity.attachments.length > 0 && !this._validateFilesSize()) {
                return false;
            }

            this._clearFilesError();
            return true;
        }

        if (key === 'consent' && opportunity.attachments.length <= 0 && !this.state.skipFiles) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('fieldRequired') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        this.setState(state => ({
            errors: { ...state.errors, [key]: '' },
            isValid: { ...state.isValid, [key]: true }
        }));

        return true;
    }

    _onSubmit = () => {
        const isValid = !Object.keys(this.state.isValid).filter(key => {
            return !this._validateInput(key);
        }).length;

        if (!isValid) {
            return false;
        }

        return new Promise(resolve => { resolve(true); });
    }

    render() {
        const { skipFiles, errors } = this.state;
        const { attachments } = this.props.opportunity;

        return (
            <Wrapper>
                <Description>
                    Last opp siste karakterutskrifter, eller dokumentasjon på annen relevant erfaring.
                    Ikke last opp sensitiv informasjon som legeerklæringer, for eksempel.
                </Description>
                <Container>
                    <UploadWrapper>
                        <FileBase64 type="file" key={Math.random().toString(36)} multiple onDone={this._onFileUploaded.bind(this)} />
                        <Paperclip />
                        <span>Finn filer</span>
                    </UploadWrapper>
                    <InputRow>
                        <Checkbox checked={skipFiles} labelWhite white onChange={this._handleSkipFiles.bind(this)} onBlur={() => this._validateInput('consent')} label="Jeg har ikke/ønsker ikke å sende dokumentasjon" error={errors.consent} />
                    </InputRow>
                </Container>
                <UploadedFilesList error={errors.files}>
                        {attachments && attachments.map((file, index) => {
                            return (
                                <UploadedFileItem key={index}>
                                    <RemoveIcon onClick={() => this._onRemoveFile(file)} />
                                    <span>{file.name}</span>
                                </UploadedFileItem>
                            )
                        })}
                    </UploadedFilesList>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    addCheckoutOpportunityAttachment,
    removeCheckoutOpportunityAttachment,
    resetCheckoutOpportunityAttachments
}

export default connect(mapStateToProps, actions)(FileUpload);


// WEBPACK FOOTER //
// ./src/partials/Checkout/FileUpload.js